import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/bootstrap.min.css";
import "./assets/styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import ProfileScreen from "./screens/ProfileScreen";
import SignupScreen from "./screens/SignupScreen";
import OtpScreen from "./screens/OtpScreen";
import PrivateRoute from "./components/PrivateRoute";
import YearlyReportScreen from "./screens/Admin/YearlyReportScreen";
import AdminRoute from "./components/AdminRoute";
import DashboardScreen from "./screens/Admin/DashboardScreen";
import SalarySlipScreen from "./screens/Admin/SalarySlipScreen";
import LeaveRegisterFormScreen from "./screens/Admin/LeaveRegisterFormScreen";
import EmployeePersonalFileDataScreen from "./screens/Admin/EmployeePersonalFileDataScreen";
import SalarySheetSummaryScreen from "./screens/Admin/SalarySheetSummaryScreen";
import AttendanceRegisterFormScreen from "./screens/Admin/AttendanceRegisterFormScreen";
import EmployeeFullFinalScreen from "./screens/Admin/EmployeeFullFinalScreen";
import SalarySlipHindiEnglishScreen from "./screens/Admin/SalarySlipHindiEnglishScreen";
import OverTimeRegisterScreen from "./screens/Admin/OverTimeRegisterScreen";
import BonusFormCScreen from "./screens/Admin/BonusFormCScreen";
import GratuityReport from "./screens/Admin/GratuityReport";
import LeaveRegisterFormScreen14 from "./screens/Admin/LeaveRegisterFormScreen14";
import BonusMonthlyScreen from "./screens/Admin/BonusMonthly";
import Form21 from "./screens/Admin/Form21";
import Form22 from "./screens/Admin/Form22";
import Form25 from "./screens/Admin/Form25";
import Form24 from "./screens/Admin/Form24";
import FaceAuth from "./screens/Admin/FaceAuth";
import AttendanceReports from "./screens/Admin/AttendanceReports";
import SendNotificationScreen from "./screens/Admin/SendNotificationScreen";
import NotificationList from "./screens/Admin/NotificationList";
import AdminDashboard from "./screens/Admin/AdminDashboard";
import LeaveApplicationScreen from "./screens/LeaveApplicationScreen";
import UserDashboardScreen from "./screens/UserDashboardScreen";
import LeaveApplicationManagementScreen from "./screens/Admin/LeaveApplicationManagementScreen";
import AttendanceScreen from "./screens/AttendanceScreen";
import AdminAttendanceManagementScreen from "./screens/Admin/AdminAttendanceManagementScreen";
import AdminFaceAuth from "./screens/Admin/AdminFaceAuth";
import AdminAttendanceReports from "./screens/Admin/AdminAttendanceReports";
import AdminAttendanceReviewScreen from "./screens/Admin/AdminAttendanceReviewScreen";
import StaffDailyAttendanceListScreen from "./screens/StaffDailyAttendanceListScreen";
import StaffAttendanceListScreen from "./screens/StaffAttendanceListScreen";
import StaffMonthlyAttendanceScreen from "./screens/StaffMonthlyAttendanceScreen";
import AdminDailyAttendanceScreen from "./screens/Admin/AdminDailyAttendanceScreen";
import AdminMonthlyAttendanceScreen from "./screens/Admin/AdminMonthlyAttendanceScreen";
import QuickInfoDashboard from "./screens/Admin/QuickInfoDashboard";

import PFMonthwiseSummary from "./screens/Admin/PFMonthwiseSummary";
import YearlyMandaysReport from "./screens/Admin/YearlyMandaysReport";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/forgot" element={<ForgotPasswordScreen />} />
      <Route path="/signup" element={<SignupScreen />} />
      <Route path="/otp" element={<OtpScreen />} />
      <Route path="/send-notification" element={<SendNotificationScreen />} />
      <Route path="/notification-list" element={<NotificationList />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="" element={<PrivateRoute />}>
        <Route index={true} path="/" element={<UserDashboardScreen />} />
        <Route path="/staff-salary-sheet" element={<HomeScreen />} />
        <Route path="/yearly" element={<YearlyReportScreen />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/attendance" element={<AttendanceScreen />} />
        <Route path="/face-auth" element={<FaceAuth />} />
        <Route path="/attendance-reports" element={<AttendanceReports />} />
        <Route path="/leave-application" element={<LeaveApplicationScreen />} />
        <Route path="/staff-daily-attendance" element={<StaffDailyAttendanceListScreen />} />
        <Route path="/staff-attendance-list" element={<StaffAttendanceListScreen />} />
        <Route path="/staff-monthly-attendance" element={<StaffMonthlyAttendanceScreen />} />
        <Route path="/admin-attendance-management" element={<AdminAttendanceManagementScreen />} />
        <Route path="/admin-face-auth" element={<AdminFaceAuth />} />
        <Route path="/admin-attendance-reports" element={<AdminAttendanceReports />} />
        <Route path="/admin-attendance-review" element={<AdminAttendanceReviewScreen />} />
      </Route>
      <Route path="" element={<AdminRoute />}>
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/quick-info-dashboard" element={<QuickInfoDashboard />} />
        <Route path="/salary-slip" element={<SalarySlipScreen />} />
        <Route path="/leave-register-form-14" element={<LeaveRegisterFormScreen />} />
        <Route path="/leave-register-form-14-15" element={<LeaveRegisterFormScreen14 />} />
        <Route path="/employee-personal-file-data" element={<EmployeePersonalFileDataScreen />} />
        <Route path="/salary-sheet-summary" element={<SalarySheetSummaryScreen />} />
        <Route path="/attendance-register-form-12" element={<AttendanceRegisterFormScreen />} />
        <Route path="/employee-full-final" element={<EmployeeFullFinalScreen />} />
        <Route path="/salary-slip-hindi-english" element={<SalarySlipHindiEnglishScreen />} />
        <Route path="/overtime-register" element={<OverTimeRegisterScreen />} />
        <Route path="/bonus-form-c" element={<BonusFormCScreen />} />
        <Route path="/bonus-monthly" element={<BonusMonthlyScreen />} />
        <Route path="/gratuity-report" element={<GratuityReport />} />
        <Route path="/form-21" element={<Form21 />} />
        <Route path="/form-22" element={<Form22 />} />
        <Route path="/form-24" element={<Form24 />} />
        <Route path="/form-25" element={<Form25 />} />
        <Route path="/leave-application-management" element={<LeaveApplicationManagementScreen />} />
        <Route path="/admin-daily-attendance" element={<AdminDailyAttendanceScreen />} />
        <Route path="/admin-monthly-attendance" element={<AdminMonthlyAttendanceScreen />} />
        <Route path="/pfmonthwisesummary" element={<PFMonthwiseSummary />} />
        <Route path="/yearlymandaysreport" element={<YearlyMandaysReport/>} />
        
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
